import Box from '@mui/material/Box';

interface SkeletonLoaderProps {
  isLoading: boolean;
  count?: number;
  children: React.ReactNode;
}

const SkeletonCard = () => (
  <Box
    sx={{
      backgroundColor: 'white',
      borderRadius: 3,
      p: 3,
      display: 'flex',
      gap: 2,
      alignItems: 'center',
    }}
  >
    <Box
      sx={{
        width: 80,
        height: 80,
        borderRadius: '50%',
        backgroundColor: '#E0E0E0',
        flexShrink: 0,
        animation: 'pulse 1.5s ease-in-out infinite',
      }}
    />
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box
        sx={{
          width: '30%',
          height: 20,
          borderRadius: 1,
          backgroundColor: '#E0E0E0',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}
      />
      <Box
        sx={{
          width: '50%',
          height: 16,
          borderRadius: 1,
          backgroundColor: '#E0E0E0',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}
      />
      <Box
        sx={{
          width: '40%',
          height: 16,
          borderRadius: 1,
          backgroundColor: '#E0E0E0',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}
      />
    </Box>
    <style>{`
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.4; }
      }
    `}</style>
  </Box>
);

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ isLoading, count = 3, children }) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {Array.from({ length: count }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </Box>
    );
  }

  return <>{children}</>;
};

export default SkeletonLoader;
